import React from "react"
import { useTranslation } from "react-i18next";
import PopOver from "../../global/PopOver";


const InvoiceReferenceFields = ({disabled, invoiceState, handleInvoiceChange, errors}) => {
  const { t } = useTranslation("translations");

  return (
    <>
    <div className="row align-items-end">
      <div className="col-md-4">
        <label className="label-txt" style={{whiteSpace:"nowrap"}}>
          {t("invoiceReferenceFields.buyerReference")}
          <PopOver title={t("invoiceReferenceFields.buyerReferenceDescription")} />
        </label>
        <input
          name="buyerReference"
          type="text"
          className={`form-control form-control-sm ${
            errors?.referenceData?.buyerReference && "is-invalid"
          }`}
          disabled={disabled}
          value={invoiceState?.referenceData?.buyerReference ?? ""}
          onChange={(e) =>
            handleInvoiceChange(e?.target?.value, "referenceData.buyerReference")
          }
        />
      </div>
      <div className="col-md-4">
        <label className="label-txt" style={{whiteSpace:"nowrap"}}>
          {t("invoiceReferenceFields.projectReference")}
          <PopOver title={t("invoiceReferenceFields.projectReferenceDescription")} />
        </label>
        <input
          name="projectReference"
          type="text"
          className={`form-control form-control-sm ${
            errors?.referenceData?.projectReference && "is-invalid"
          }`}
          disabled={disabled}
          value={invoiceState?.referenceData?.projectReference ?? ""}
          onChange={(e) =>
            handleInvoiceChange(e?.target?.value, "referenceData.projectReference")
          }
        />
      </div>
      <div className="col-md-4">
        <label className="label-txt" style={{whiteSpace:"nowrap"}}>
          {t("invoiceReferenceFields.contractReference")}
          <PopOver title={t("invoiceReferenceFields.contractReferenceDescription")} />
        </label>
        <input
          name="contractReference"
          type="text"
          className={`form-control form-control-sm ${
            errors?.referenceData?.contractReference && "is-invalid"
          }`}
          disabled={disabled}
          value={invoiceState?.referenceData?.contractReference ?? ""}
          onChange={(e) =>
            handleInvoiceChange(e?.target?.value, "referenceData.contractReference")
          }
        />
      </div>
    </div>
    <div className="row align-items-end">
      <div className="col-md-4">
        <label className="label-txt" style={{whiteSpace:"nowrap"}}>
          {t("invoiceReferenceFields.purchaseOrderReference")}
          <PopOver title={t("invoiceReferenceFields.purchaseOrderReferenceDescription")} />
        </label>
        <input
          name="purchaseOrderReference"
          type="text"
          className={`form-control form-control-sm ${
            errors?.referenceData?.purchaseOrderReference && "is-invalid"
          }`}
          disabled={disabled}
          value={invoiceState?.referenceData?.purchaseOrderReference ?? ""}
          onChange={(e) =>
            handleInvoiceChange(e?.target?.value, "referenceData.purchaseOrderReference")
          }
        />
      </div>
      <div className="col-md-4">
        <label className="label-txt" style={{whiteSpace:"nowrap"}}>
          {t("invoiceReferenceFields.salesOrderReference")}
          <PopOver title={t("invoiceReferenceFields.salesOrderReferenceDescription")} />
        </label>
        <input
          name="salesOrderReference"
          type="text"
          className={`form-control form-control-sm ${
            errors?.referenceData?.salesOrderReference && "is-invalid"
          }`}
          disabled={disabled}
          value={invoiceState?.referenceData?.salesOrderReference ?? ""}
          onChange={(e) =>
            handleInvoiceChange(e?.target?.value, "referenceData.salesOrderReference")
          }
        />
      </div>
      <div className="col-md-4">
        <label className="label-txt" style={{whiteSpace:"nowrap"}}>
          {t("invoiceReferenceFields.receiptReference")}
          <PopOver title={t("invoiceReferenceFields.receiptReferenceDescription")} />
        </label>
        <input
          name="receiptReference"
          type="text"
          className={`form-control form-control-sm ${
            errors?.referenceData?.receiptReference && "is-invalid"
          }`}
          disabled={disabled}
          value={invoiceState?.referenceData?.receiptReference ?? ""}
          onChange={(e) =>
            handleInvoiceChange(e?.target?.value, "referenceData.receiptReference")
          }
        />
      </div>
    </div>
    <div className="row align-items-end">
      <div className="col-md-4">
        <label className="label-txt" style={{whiteSpace:"nowrap"}}>
          {t("invoiceReferenceFields.despatchNoteReference")}
          <PopOver title={t("invoiceReferenceFields.despatchNoteReferenceDescription")} />
        </label>
        <input
          name="despatchNoteReference"
          type="text"
          className={`form-control form-control-sm ${
            errors?.referenceData?.despatchNoteReference && "is-invalid"
          }`}
          disabled={disabled}
          value={invoiceState?.referenceData?.despatchNoteReference ?? ""}
          onChange={(e) =>
            handleInvoiceChange(e?.target?.value, "referenceData.despatchNoteReference")
          }
        />
      </div>
      <div className="col-md-4">
        <label className="label-txt" style={{whiteSpace:"nowrap"}}>
          {t("invoiceReferenceFields.requestForBidReference")}
          <PopOver title={t("invoiceReferenceFields.requestForBidReferenceDescription")} />
        </label>
        <input
          name="requestForBidReference"
          type="text"
          className={`form-control form-control-sm ${
            errors?.referenceData?.requestForBidReference && "is-invalid"
          }`}
          disabled={disabled}
          value={invoiceState?.referenceData?.requestForBidReference ?? ""}
          onChange={(e) =>
            handleInvoiceChange(e?.target?.value, "referenceData.requestForBidReference")
          }
        />
      </div>
      <div className="col-md-4">
        <label className="label-txt" style={{whiteSpace:"nowrap"}}>
          {t("invoiceReferenceFields.schemaIdentifier")}
          <PopOver title={t("invoiceReferenceFields.schemaIdentifierDescription")} />
        </label>
        <input
          name="schemaIdentifier"
          type="text"
          className={`form-control form-control-sm ${
            errors?.referenceData?.schemaIdentifier && "is-invalid"
          }`}
          disabled={disabled}
          value={invoiceState?.referenceData?.schemaIdentifier ?? ""}
          onChange={(e) =>
            handleInvoiceChange(e?.target?.value, "referenceData.schemaIdentifier")
          }
        />
      </div>
    </div>

    </>
  );
};

export default InvoiceReferenceFields;